var map = {
	"./backslash.png": "3671",
	"./certifications/cert0.png": "fe70",
	"./certifications/cert1.png": "18e2",
	"./certifications/cert10.png": "20af",
	"./certifications/cert11.png": "d531",
	"./certifications/cert12.png": "83e6",
	"./certifications/cert13.png": "5d10",
	"./certifications/cert14.png": "0c37",
	"./certifications/cert15.png": "24dd",
	"./certifications/cert16.png": "c6ba",
	"./certifications/cert17.png": "402a",
	"./certifications/cert18.png": "7b35",
	"./certifications/cert19.png": "b316",
	"./certifications/cert2.png": "c15a",
	"./certifications/cert20.png": "5192",
	"./certifications/cert21.png": "fd6b",
	"./certifications/cert22.png": "5aeb",
	"./certifications/cert23.png": "60bf",
	"./certifications/cert24.png": "156f",
	"./certifications/cert25.png": "1db8",
	"./certifications/cert26.png": "bc6f",
	"./certifications/cert27.png": "80da",
	"./certifications/cert28.png": "4906",
	"./certifications/cert29.png": "c7f9",
	"./certifications/cert3.png": "6f64",
	"./certifications/cert30.png": "32de",
	"./certifications/cert31.png": "97f2",
	"./certifications/cert32.png": "06c0",
	"./certifications/cert33.png": "92f7",
	"./certifications/cert34.png": "173e",
	"./certifications/cert35.png": "c76f",
	"./certifications/cert4.png": "1d81",
	"./certifications/cert5.png": "7c60",
	"./certifications/cert6.png": "46db",
	"./certifications/cert7.png": "f50c",
	"./certifications/cert8.png": "9754",
	"./certifications/cert9.png": "80e5",
	"./certifications/removed/cert18.png": "0430",
	"./certifications/removed/cert19.png": "7961",
	"./certifications/removed/cert5.png": "580c",
	"./finance.png": "bc1e",
	"./healthcare.png": "257b",
	"./home/finance-home.jpg": "a8ae",
	"./home/health-care-home.jpg": "9f64",
	"./home/hospitality-home.jpg": "c55d",
	"./home/hotels-home.jpg": "41aa",
	"./home/slide1.jpg": "0859",
	"./home_carousel_image_1.png": "048e",
	"./home_carousel_image_2.png": "d185",
	"./home_carousel_image_3.png": "2e16",
	"./home_carousel_image_4.png": "5a84",
	"./home_carousel_image_5.png": "7745",
	"./hospitality.png": "923a",
	"./hyatt-1.png": "d360",
	"./hyatt-2.png": "fc5e",
	"./hyatt.png": "7f11",
	"./ibms.png": "5539",
	"./industries-1.png": "9bda",
	"./industries-2.png": "080a",
	"./industries/airport.png": "8648",
	"./industries/avs.jpg": "a9c9",
	"./industries/banking.jpg": "07d7",
	"./industries/corp.png": "d935",
	"./industries/corporate.jpg": "69f9",
	"./industries/das.jpg": "971a",
	"./industries/education.jpg": "2f33",
	"./industries/education.png": "0753",
	"./industries/finance.png": "aa3c",
	"./industries/finance2.png": "75ee",
	"./industries/govt.png": "205d",
	"./industries/healthcare.jpg": "daf5",
	"./industries/healthcare.png": "c2a4",
	"./industries/healthcare2.png": "5646",
	"./industries/hospitality.jpg": "ddd3",
	"./industries/hospitality.png": "7bee",
	"./industries/hotel.jpg": "0672",
	"./industries/hotel.png": "2604",
	"./industries/ites.jpg": "584a",
	"./industries/mall.jpg": "3266",
	"./industries/mall.png": "6a26",
	"./industries/mall2.png": "5ac6",
	"./industries/old/airport.png": "232d",
	"./industries/old/corp.png": "66f0",
	"./industries/old/education.png": "1bd9",
	"./industries/old/finance.png": "308f",
	"./industries/old/govt.png": "2392",
	"./industries/old/healthcare.png": "dd54",
	"./industries/old/hospitality.png": "ed4a",
	"./industries/old/hotel.png": "0d8e",
	"./industries/old/mall.png": "f084",
	"./industries_new_2.png": "4950",
	"./industries_news_1.png": "93b3",
	"./industries_news_light_1.png": "7b34",
	"./industries_news_light_2.png": "b6c8",
	"./industry.png": "bafc",
	"./ites.png": "e8a9",
	"./logo.png": "9d64",
	"./mall.png": "f742",
	"./placeholder.png": "aa6f",
	"./project.png": "807b",
	"./projects/Airport_Shipyard/Cochin_Shipyard/1.jpeg": "72df",
	"./projects/Airport_Shipyard/Cochin_airport/1.jpg": "d445",
	"./projects/Airport_Shipyard/Cochin_airport/2.jpg": "fe93",
	"./projects/Airport_Shipyard/Kannur_airport/1.jpg": "eb5b",
	"./projects/Airport_Shipyard/Kannur_airport/2.jpg": "6f1a",
	"./projects/Airport_Shipyard/Kannur_airport/3.jpg": "4f6c",
	"./projects/Airport_Shipyard/calicut_international_airport/1.jpg": "1aa0",
	"./projects/Airport_Shipyard/mumbai_airport/1.jpeg": "985a",
	"./projects/Airport_Shipyard/petronet_lng/1.png": "7209",
	"./projects/Believers-Church-Seminary-and-School.jpg": "86ea",
	"./projects/Central-Marine-Fisheries-Research-Institute-(CMFRI).jpg": "c3f8",
	"./projects/City-Marriott-Hotel-Kochi.jpg": "1876",
	"./projects/Cochin-Shipyard-Ltd.jpg": "2299",
	"./projects/DM-Healthcare-Pvt-Ltd.jpg": "4bb1",
	"./projects/ESAF.jpg": "49302",
	"./projects/Emmay-Logistics.jpg": "bfa9",
	"./projects/Federal-Bank.jpg": "dc54",
	"./projects/Hotel-Olive-Downtown.jpg": "b210",
	"./projects/Hyatt-Regency-and-Lulu-Convention-Center.jpg": "23ec",
	"./projects/Incheon-Motors.jpg": "88a3",
	"./projects/Indian-Navy.jpg": "6d4b",
	"./projects/Kasargod-Medical-College-(Kitco).jpg": "c758",
	"./projects/Kerala-Sec.jpg": "227f",
	"./projects/LPSC.jpg": "77ca",
	"./projects/Lakeshore-Hospitals.jpg": "b7b6",
	"./projects/Larsen-&-Toubro.jpg": "9354",
	"./projects/Lulu-Flight-Kitchen.jpg": "d1c9",
	"./projects/Lulu-mall-kochi.jpg": "50d1",
	"./projects/MG-University.jpg": "372b",
	"./projects/MVR-Cancer-Center.jpg": "a075",
	"./projects/MVR-Palliative-Care.jpg": "65f2",
	"./projects/Mall-of-Joy.jpg": "9867",
	"./projects/Marriott-Hotel-Courtyard.jpg": "aa35",
	"./projects/Providence-College-of-Engineering.jpg": "e6e1",
	"./projects/South-Indian-Bank.jpg": "865d",
	"./projects/TAJ-Hotel-Wayanad.jpg": "8746",
	"./projects/V-Guard-Industries-Ltd.jpg": "0d90",
	"./projects/corporate/L_T/1.jpg": "6b61",
	"./projects/corporate/Parle_agro/1.jpg": "df46",
	"./projects/corporate/Shapoorji_pallonji/1.jpg": "f0d5",
	"./projects/corporate/V-Guard/1.jpg": "c402",
	"./projects/corporate/Voltas/1.png": "a554",
	"./projects/corporate/lufthansa/1.jpg": "d6f5",
	"./projects/corporate/lufthansa/2.jpg": "6e20",
	"./projects/corporate/raymond/1.jpg": "c334",
	"./projects/corporate/reliance_industries/1.jpg": "f0c4",
	"./projects/corporate/reliance_industries/2.jpg": "05c4",
	"./projects/corporate/shell_india/1.jpg": "b270",
	"./projects/education/Govt_college_of_engg_srikrishnapuram/1.jpg": "c9c0",
	"./projects/education/MG_U.city/1.jpg": "fd1b",
	"./projects/education/MG_U.city/2.jpg": "ed5a",
	"./projects/education/believers/1.jpg": "531a",
	"./projects/education/lakshadweep_school/1.jpg": "7447",
	"./projects/education/providence_college_of_engg/1.jpg": "fc2c",
	"./projects/education/providence_college_of_engg/2.jpg": "3452",
	"./projects/education/sanskrit_college/1.jpeg": "562f",
	"./projects/education/sanskrit_college/2.jpg": "f8b2",
	"./projects/finance/DHANAKSHMI/1.jpg": "029a",
	"./projects/finance/ESAF/1.jpg": "4e85",
	"./projects/finance/South_indian_bank/1.jpg": "c6cc",
	"./projects/finance/axis.png": "a614",
	"./projects/finance/axis2.jpg": "c3a2",
	"./projects/finance/axis3.jpeg": "46ab",
	"./projects/finance/canara.jpg": "a952",
	"./projects/finance/canara.png": "93d8",
	"./projects/finance/canara2.jpg": "e6a8",
	"./projects/finance/federal_bank/1.jpg": "f490",
	"./projects/finance/ksfe.jpeg": "7d67",
	"./projects/finance/ksfe2.jpeg": "5701",
	"./projects/finance/oriental.png": "c2d2",
	"./projects/finance/union_bank/1.jpg": "bfd1",
	"./projects/govt/cmfri.jpg": "61ab",
	"./projects/govt/coir-board.jpg": "1226",
	"./projects/govt/hal.jpg": "3c77",
	"./projects/govt/india-post.jpg": "6f0d",
	"./projects/govt/indian-navy.jpg": "d988",
	"./projects/govt/irel.jpg": "6fc8",
	"./projects/govt/kerala-gov.jpg": "1d8e",
	"./projects/govt/lpsc.jpg": "82e7",
	"./projects/govt/office-of-textile.jpg": "ca94",
	"./projects/govt/prasarbharati.jpg": "6bee",
	"./projects/healthcare/GT Hospital/1.jpg": "4a59",
	"./projects/healthcare/Glenmark/1.jpg": "2ebc",
	"./projects/healthcare/Mar Sleeva medicity/1.jpg": "09a6",
	"./projects/healthcare/Welcare hostital/1.jpg": "f963",
	"./projects/healthcare/dm/1.jpg": "8eec",
	"./projects/healthcare/kasargod medical college/1.jpg": "bcb2",
	"./projects/healthcare/lakeshore hospital/1.jpg": "96b1",
	"./projects/healthcare/mvr cancer centre/1.jpg": "b8e8",
	"./projects/healthcare/mvr palliative/1.jpg": "a35f",
	"./projects/healthcare/pushpagiri medical college/1.jpg": "6358",
	"./projects/healthcare/rajagiri hospital/1.jpg": "d624",
	"./projects/healthcare/st.george hospital/1.jpg": "9094",
	"./projects/hospitality/City_marriot_hotel_kochi/1.jpg": "1bc1",
	"./projects/hospitality/Grand_Hyatt/1.jpg": "c70f",
	"./projects/hospitality/Hotel_Mirador/1.jpg": "7f2e",
	"./projects/hospitality/Hotel_diplomat/1.jpeg": "00e8",
	"./projects/hospitality/Hotel_olive_down_town/1.jpg": "ba76",
	"./projects/hospitality/Hyatt_regency_Lulu_convention_centre/1.jpeg": "2c23",
	"./projects/hospitality/Lulu_Flight_Kitchen/1.jpg": "9f4a",
	"./projects/hospitality/Mariott_hotel_courtyard/1.jpg": "ed56",
	"./projects/hospitality/Recidency_hotel/1.jpg": "2869",
	"./projects/hospitality/hotel_oberoi/1.jpg": "345c",
	"./projects/hospitality/taj_hotel_wayanad/1.jpg": "088e",
	"./projects/shopping_mall_IT_infra/Lulu_mall/1.jpeg": "b134",
	"./projects/shopping_mall_IT_infra/Mantle_solution/1.jpg": "6dec",
	"./projects/shopping_mall_IT_infra/Mariapps/1.jpg": "3f37",
	"./projects/shopping_mall_IT_infra/Nippon_infra/1.jpg": "551f",
	"./projects/shopping_mall_IT_infra/Y-mall/1.jpg": "8ef8",
	"./projects/shopping_mall_IT_infra/accenture/1.jpg": "ca04",
	"./projects/shopping_mall_IT_infra/mall_of_joy/1.jpg": "fa30",
	"./services/aiot.png": "c558",
	"./services/cc.png": "651a",
	"./services/datacenter.png": "b396",
	"./services/ess.png": "6e79",
	"./services/ibms.png": "8f9a",
	"./services/icons/aiot.png": "0ab9",
	"./services/icons/aiot2.png": "3483",
	"./services/icons/aiot3.png": "8f0b",
	"./services/icons/avs.png": "eae8",
	"./services/icons/avs2.png": "e26c",
	"./services/icons/avs3.png": "88ef",
	"./services/icons/cc.png": "d8a3",
	"./services/icons/cc2.png": "c7df",
	"./services/icons/cc3.png": "510d",
	"./services/icons/das.png": "f2a7",
	"./services/icons/das2.png": "e81c",
	"./services/icons/das3.png": "45c5",
	"./services/icons/dcs.png": "1374",
	"./services/icons/dcs2.png": "924c",
	"./services/icons/dcs3.png": "efa0",
	"./services/icons/ess.png": "af78",
	"./services/icons/ess2.png": "e78e",
	"./services/icons/ess3.png": "c56f",
	"./services/icons/ibms.png": "530a",
	"./services/icons/ibms2.png": "0e1c",
	"./services/icons/ibms3.png": "aac2",
	"./services/icons/ites.png": "ed2c",
	"./services/icons/ites2.png": "44d4",
	"./services/icons/ites3.png": "d984",
	"./services/securecloud.png": "98b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7584";